import React from "react";
import { ProductConsumer } from "../../context";
import { Link } from "react-router-dom";

export default function CartTotals() {
  return (
    <div className="container">
      <div className="row">
        <ProductConsumer>
          {(value) => {
            const { clearCart, cartSubTotal, cartTax, cartTotal } = value;

            return (
              <div className="col text-title text-center my-4">
                <button className="main-link mx-3" onClick={clearCart}>
                  Nulstil Kurv
                </button>
                <Link
                  to="/"
                  className="main-link"
                  style={{ margin: "0.75rem" }}
                >
                  Tilbage til Menu
                </Link>
                {(() => {
                  if (cartTotal > 0) {
                    return (
                      <Link
                        to="/orderinfo"
                        className="main-link"
                        style={{ margin: "0.75rem" }}
                      >
                        bestill
                      </Link>
                    );
                  }
                })()}

                <h3>subtotal : {cartSubTotal} kr</h3>
                <h3>moms : {cartTax} kr</h3>
                <h3>total : {cartTotal} kr</h3>
              </div>
            );
          }}
        </ProductConsumer>
      </div>
    </div>
  );
}
